import { euclideanDistance } from '@/utils/GridUtils';
import { inverseSquareFalloff } from '@/utils/MathUtils';

interface LightSource {
  col: number;
  row: number;
  radius: number;
}

/**
 * Computes light coverage from lasers and strobes.
 * Same inverse-square model as sound.
 */
export class LightCoverageMap {
  private readonly cols: number;
  private readonly rows: number;
  private coverage: Float32Array;

  constructor(cols: number, rows: number) {
    this.cols = cols;
    this.rows = rows;
    this.coverage = new Float32Array(cols * rows);
  }

  recalculate(sources: LightSource[]): void {
    this.coverage.fill(0);

    for (const src of sources) {
      for (let row = 0; row < this.rows; row++) {
        for (let col = 0; col < this.cols; col++) {
          const dist = euclideanDistance(col, row, src.col, src.row);
          const value = inverseSquareFalloff(dist, src.radius);
          const idx = row * this.cols + col;
          this.coverage[idx] = Math.min(1, this.coverage[idx] + value);
        }
      }
    }
  }

  getCoverage(col: number, row: number): number {
    if (col < 0 || col >= this.cols || row < 0 || row >= this.rows) return 0;
    return this.coverage[row * this.cols + col];
  }
}
